/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { Store } from '@ngxs/store';
import { ZoomButtonElementComponent } from './zoom-button-element.component';

@NgModule({
    imports: [ ZoomButtonElementComponent ],
    exports: [ ZoomButtonElementComponent ],
    providers: [ Store ]
})
export class ZoomButtonElementModule {
    constructor(private injector: Injector) {
        const el = createCustomElement(ZoomButtonElementComponent, {
            injector: this.injector
        });
        customElements.define('dash-gis-zoom-button-element', el);
    }
}
